export const EMOTIONS = ["kaygi", "endise", "korku", "anksiyete", "tehlike", "tedirginlik"];

export const EMOTION_LABELS_TR = {
  kaygi: "Kaygı",
  endise: "Endişe",
  korku: "Korku",
  anksiyete: "Anksiyete",
  tehlike: "Tehlike",
  tedirginlik: "Tedirginlik",
};

export const EMOTION_EMOJI = {
  kaygi: "😟",
  endise: "😨",
  korku: "😱",
  anksiyete: "😰",
  tehlike: "⚠️",
  tedirginlik: "😬",
};

export const EMOTION_COLORS = {
  kaygi: "#F97316",
  endise: "#EF4444",
  korku: "#1E3A8A",
  anksiyete: "#A855F7",
  tehlike: "#DC2626",
  tedirginlik: "#EAB308",
};

export const POLARITY_LABELS_TR = {
  positive: "Olumlu",
  neutral: "Nötr",
  negative: "Olumsuz",
};

export const POLARITY_COLORS = {
  positive: "#22C55E",
  neutral: "#9CA3AF",
  negative: "#EF4444",
};

export const WAR_STANCE_LABELS_TR = {
  pro_war: "Savaş Yanlısı",
  neutral: "Tarafsız",
  pro_peace: "Barış Yanlısı",
};

export const WAR_STANCE_COLORS = {
  pro_war: "#EF4444",
  neutral: "#EAB308",
  pro_peace: "#22C55E",
};

export const RESEARCH_START = "2026-02-15";
export const RESEARCH_END = "2026-03-15";

export function formatDateTR(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("tr-TR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatDateOnlyTR(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("tr-TR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
